import { DefaultLayout } from '@fondationcss/ui';

export const getCustomRoutes = () => [
  {
    path: '/',
    component: DefaultLayout,
    meta: { title: 'Scheduler' },
    children: [
      {
        // La page d'accueil repond a la question centrale — plus rapide, et de
        // meilleure qualite ? — au lieu de deverser la liste des jobs.
        name: 'overview',
        path: '',
        component: () => import('@/views/overview-view.vue'),
      },
      {
        name: 'jobs',
        path: 'jobs',
        component: () => import('@/views/jobs-view.vue'),
      },
      {
        name: 'job-detail',
        path: 'jobs/:id',
        component: () => import('@/views/job-detail-view.vue'),
      },
      {
        name: 'queue',
        path: 'file',
        component: () => import('@/views/queue-view.vue'),
      },
      {
        name: 'comparison',
        path: 'comparaison',
        component: () => import('@/views/comparison-view.vue'),
      },
      {
        name: 'environments',
        path: 'environnements',
        component: () => import('@/views/environments-view.vue'),
      },
      {
        name: 'tenants',
        path: 'locataires',
        component: () => import('@/views/tenants-view.vue'),
      },
      {
        name: 'images',
        path: 'versions',
        component: () => import('@/views/images-view.vue'),
      },
      // Conservée : elle regroupe locataires et versions sur une seule page.
      // Les deux pages dédiées ci-dessus la remplacent dans le menu, mais un
      // signet existant ne doit pas tomber sur une 404.
      {
        name: 'administration',
        path: 'administration',
        component: () => import('@/views/administration-view.vue'),
      },
    ],
  },
];
